module.exports = __webpack_public_path__ + "static/media/hide.712dec09.svg";